export default function Header() {
  return (
    <div className="h-60 bg-gradient-to-b from-primary to-secondary text-center py-8 text-gray-50 shrink-0">
      <h1 className="font-light text-xl tracking-wider">Unofficial</h1>
      <h1 className="font-medium text-5xl">KBBI</h1>
    </div>
  )
}